import { registerNewBatch, deliverFiles } from "../../../../upload/services/batchActions";
import { stageFilesLocally, finalizeLocalBatch } from "../../../../upload/services/storageService";

/**
 * 🛰️ MODIFIED: SaveESG_taxonomyController
 * Behavior: Aligned with AutomatedCleanBucketUpload hydration logic.
 * Target: esg-staging-clean (Clean Bucket).
 * Preservation: Maintains the virtual/dummy JSON file for diagnostic syncing.
 */
export const SaveESG_taxonomyController = {
    promoteToCleanRoute: async (siteKey) => {
        // 1. DYNAMIC SYSTEM VARIABLES
        const currentYear = new Date().getFullYear();
        // Updated naming convention to reflect the "Clean" destination
        const generateTargetRoot = (year) => `esg-clean-taxonomy-${year}`;

        // 2. PRESERVED: DUMMY DATA BLOB (Diagnostic Payload)
        const dummyPot = [{ uid: `test_${Date.now()}`, label: "Diagnostic_Clean_Sync" }];
        const fileName = `ESG_Clean_Sync_${Date.now()}.json`;
        const blob = new Blob([JSON.stringify(dummyPot)], { type: "application/json" });
        const virtualFile = new File([blob], fileName, { type: "application/json" });

        // 3. HYDRATED METADATA: Aligned with AutomatedCLean logic
        // Explicitly targeting the 'esg-staging-clean' bucket while maintaining React-standard keys
        const siteMetaData = {
            reportingYear: currentYear,
            versionLabel: "Automated Clean System Sync",
            S3CorsValue: "esg",                    // Mandatory for Handshake validation
            targetBucket: "esg-staging-clean",     // TARGET: Clean Bucket
            targetRoot: generateTargetRoot(currentYear),
            batchType: 1                           // Standard Taxonomy Type
        };

        try {
            console.log(`🚀 INITIATING CLEAN SYNC: ${fileName} -> esg-staging-clean`);

            // STEP A: BFF Handshake (SQL Registration)
            // We pass batchType 1 to align with standard taxonomy processing
            const newBatch = await registerNewBatch(
                [virtualFile], 
                { siteKey: siteKey, batchType: 1 }, 
                siteMetaData
            );
            
            // STEP B: Dexie Staging (Local IndexedDB Buffer)
            await stageFilesLocally([virtualFile], newBatch.batchId, siteKey);
            
            // STEP C: Database Finalization (Hydrating the Batch record)
            // This ensures S3CorsValue and TargetBucket are locked into the local DB
            await finalizeLocalBatch(
                newBatch.batchId, 
                siteKey, 
                newBatch.hash, 
                newBatch.timestamp, 
                siteMetaData 
            );

            // STEP D: S3 Dispatch (Triggers JIT Authorization & XHR PUT)
            // Note: We do not pass a progress callback here as this is a background controller action
            deliverFiles(newBatch.batchId, [virtualFile], siteKey);

            return { 
                success: true, 
                batchId: newBatch.batchId, 
                fileName,
                destination: "esg-staging-clean" 
            };

        } catch (err) {
            console.error("🚨 CLEAN_ROUTE_SYNC_FAILED", err);
            throw err;
        }
    }
};